export default "/images/vendor/flag-icon-css/flags/4x3/gt.svg?c0bc6c2f50955193f6d90189a6f7dd42";